import { render, staticRenderFns } from "./Poslovnice.vue?vue&type=template&id=44ccc6de&"
import script from "./Poslovnice.vue?vue&type=script&lang=js&"
export * from "./Poslovnice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports